// Valori iniziali dei filtri utente di un widget, a partire dalle definizioni
// risolte dal backend (filter_definitions con default_value gia' calcolato).
export function widgetFilterDefaults(definitions) {
    const values = {}
    ;(definitions || []).forEach(def => {
        const d = def.default_value
        if (def.type === 'date_range') {
            values[def.key] = { from: d && d.from ? d.from : null, to: d && d.to ? d.to : null }
        } else if (def.type === 'select' && def.multiple) {
            values[def.key] = Array.isArray(d) ? [...d] : (d ? [d] : [])
        } else {
            values[def.key] = d != null && d !== '' ? d : null
        }
    })
    return values
}

// true se i valori correnti differiscono dai default delle definizioni
export function widgetFiltersChanged(definitions, values) {
    return JSON.stringify(widgetFilterDefaults(definitions)) !== JSON.stringify(values || {})
}

function formatDay(d) {
    const parts = String(d).split('-')
    return parts.length === 3 ? parts[2] + '/' + parts[1] + '/' + parts[0] : d
}

// Chip dei filtri attivi, es. [{key:'periodo', text:'Periodo 01/09/2026 – 30/09/2026'}, {key:'fonte', text:'2 fonti'}]
export function widgetFilterChips(definitions, values) {
    const chips = []
    ;(definitions || []).forEach(def => {
        const v = (values || {})[def.key]
        if (def.type === 'date_range') {
            if (v && (v.from || v.to)) {
                chips.push({ key: def.key, text: `${def.label} ${v.from ? formatDay(v.from) : '…'} – ${v.to ? formatDay(v.to) : '…'}` })
            }
        } else if (def.type === 'select') {
            const list = Array.isArray(v) ? v : (v != null && v !== '' ? [v] : [])
            if (list.length === 1) {
                const opt = (def.options || []).find(o => String(o.value) === String(list[0]))
                chips.push({ key: def.key, text: `${def.label}: ${opt ? opt.text : list[0]}` })
            } else if (list.length > 1) {
                chips.push({ key: def.key, text: `${def.label}: ${list.length} selezionati` })
            }
        } else if (v) {
            chips.push({ key: def.key, text: `${def.label}: ${v}` })
        }
    })
    return chips
}
